import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { ONE_TRUST_SCRIPT_KEY } from '../../api/util'
import {
  ConsentState,
  ONETRUST_CONSENT_UPDATE_EVENT,
  getOneTrustConsent
} from '../../utils/onetrust-utils'
import { FacebookPixel } from '../../../packages/ad-tracking/FacebookPixel'
import { GoogleTracking } from '../../../packages/ad-tracking/GoogleTracking'

/**
 * OneTrust handles the Cookies Consent Notice for www.toasttab.com.
 * This component is responsible for loading the OneTrust script
 * and any other tracking scripts if allowed.
 */
export const CompliantTrackingScriptLoader: React.FC = () => {
  const { consentState } = useConsentState()

  useEffect(() => {
    if (typeof window !== 'undefined' && !window.OptanonWrapper) {
      window.OptanonWrapper = function () {
        window.dispatchEvent(
          new CustomEvent(ONETRUST_CONSENT_UPDATE_EVENT, {
            detail: { consent: window.OptanonActiveGroups }
          })
        )
      }
    }
  }, [])

  return (
    <>
      <Helmet>
        <script
          src='https://cdn.cookielaw.org/scripttemplates/otSDKStub.js'
          type='text/javascript'
          data-domain-script={ONE_TRUST_SCRIPT_KEY}
        />
      </Helmet>

      <GoogleTracking consentState={consentState} />
      <FacebookPixel consentState={consentState} useLimitedDataUse={true} />
    </>
  )
}

/**
 * Hook that manages OneTrust consent state for all tracking categories.
 */
export const useConsentState = () => {
  const [consentState, setConsentState] = useState<ConsentState>({
    hasPerformanceConsent: false,
    hasTargetingConsent: false,
    hasFunctionalConsent: false
  })

  useEffect(() => {
    return getOneTrustConsent(setConsentState)
  }, [])

  return { consentState }
}
